<template>
    <b-table 
        :fields="columns"
        :items="formatRelated"
        bordered
        striped
        fixed
    >
        <template #cell(managed_list_id)="data">
            <a :href="`#/managed-lists/${data.item.managed_list_id}`" class="btn-link">
                {{ getManagedListById(data.item.managed_list_id).description }}
            </a>
        </template>
        <template #cell(value)="data">
            <a :href="`#/attributes-lists/${data.item.id}`" class="btn-link">
                {{ data.item.value }}
            </a>
        </template>
    </b-table>
</template>
<script>
export default {
    name: "AttributesListTable",
    props: {
        related: {
            type: Array,
            default: () => [],
        },
        managedLists: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        formatRelated() {
            return [
                ...this.related.map(({ id, value, managed_list_id }) => {
                    return {
                        id, value, managed_list_id
                    };
                })
            ];
        }
    },
    data() {
        return {
            columns: [
                {
                    key: "managed_list_id",
                    label: "List"
                },
                {
                    key: "value",
                    label: "Name"
                }
            ]
        };
    },
    methods: {
        getManagedListById(managedListId) {
            return this.managedLists.find(list => list.id === managedListId);
        }
    }
}
</script>
